import { Box, Tab, Tabs } from '@mui/material';

function a11yProps(index: number) {
    return {
        id: `cdd-agente-tab-${index}`,
        'aria-controls': `cdd-agente-tabpanel-${index}`
    };
}

function QuickFilterDataTable({ handleChangeTabValue, tabValue }: any) {
    return (
        <Box mb={2}>
            <Tabs className="history-tabs" value={tabValue} onChange={handleChangeTabValue}>
                <Tab label="Todos" {...a11yProps(0)} />
                <Tab label="Adjuntados por mi" {...a11yProps(1)} />
            </Tabs>
        </Box>
    );
}

export default QuickFilterDataTable;
